import { API_V2 } from "@/config/api";
import { Donors } from "../types/models/Donors";
import apiRequest from "./api";

export const routes = {
  donors: `${API_V2}/donors`,
  export: `${API_V2}/donors/report`,
  get: (donorId: number | string) => `${API_V2}/donors/${donorId}`,
};

export interface DonorsRequest {
  page: number;
  limit: number;
  sortBy: "createdAt" | "lastName";
  sortDirection: "ASC" | "DESC";
}

export interface DonorsResponse {
  result: Donors[];
  total: number;
  page: number;
  pages: number;
}

export const downloadDonors = () =>
  apiRequest<Buffer>(routes.export, {
    method: "GET",
  });
